// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

/**
 * This is a list of feature keys served by the apps-backend.
 */
export enum Feature {
    AccountFinder = 'account-finder',
    WalletDapps = 'wallet-dapps',
    WalletBalanceRefetchInterval = 'wallet-balance-refetch-interval',
    WalletAppsBannerConfig = 'wallet-apps-banner-config',
    WalletInterstitialConfig = 'wallet-interstitial-configuration',
    WalletPasskeys = 'wallet-passkey-accounts',
    RecognizedPackages = 'recognized-packages',
    WalletSentryTracing = 'wallet-sentry-tracing',
    PollingTxnTable = 'polling-txn-table',
    NetworkOutageOverride = 'network-outage-override',
    ModuleSourceVerification = 'module-source-verification',
    WalletEffectsOnlySharedTransaction = 'wallet-effects-only-shared-transaction',
    StardustMigration = 'migration',
    SupplyIncreaseVesting = 'supply-increase-vesting',
    FiatConversion = 'fiat-conversion',
    KnownAddressAlias = 'known-address-alias',
    KnownIotaEVMCoinTypes = 'known-iota-evm-coin-types',
    IotaNames = 'iota-names',
    ValidatorAddressAlias = 'validator-address-alias',
    ExplorerTFIdentity = 'explorer-trust-framework-identity',
}
